import React, { PropTypes } from 'react'
import { TrackedNavLink } from 'components/Buttons'
import "./CustomizeNav.css"

const CustomizeNav = ({putterId, page, confirmLink}) =>
  <ul className="customize-nav">
    <li className={['face','back','top','specs','acc','auth','confirm'].includes(page) ? "previous" : ''}>
      <TrackedNavLink trackingData="TopNav:Finish" to={`/customize/${putterId}/finish`} activeClassName="active"><span className="customize-nav-label">Finish & Paintfill</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
    <li className={['back','top','specs','acc','auth','confirm'].includes(page) ? "previous" : ''}>
      <TrackedNavLink trackingData="TopNav:Face" to={`/customize/${putterId}/face`} activeClassName="active"><span className="customize-nav-label">Face</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
    <li className={['top','specs','acc','auth','confirm'].includes(page) ? "previous" : ''}>
      <TrackedNavLink trackingData="TopNav:Back" to={`/customize/${putterId}/back`} activeClassName="active"><span className="customize-nav-label">Back</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
    <li className={['specs','acc','auth','confirm'].includes(page) ? "previous" : ''}>
      <TrackedNavLink trackingData="TopNav:Top" to={`/customize/${putterId}/top`} activeClassName="active"><span className="customize-nav-label">Top</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
    <li className={['acc','auth','confirm'].includes(page) ? "previous" : ''}>
      <TrackedNavLink trackingData="TopNav:Specs" to={`/customize/${putterId}/specs`} activeClassName="active"><span className="customize-nav-label">Specs</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
    <li className={['auth','confirm'].includes(page) ? "previous" : ''}>
      <TrackedNavLink trackingData="TopNav:Accessories" to={`/customize/${putterId}/acc`} activeClassName="active"><span className="customize-nav-label">Accessories</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
    <li className={['confirm'].includes(page) ? "previous" : ''}>
      <TrackedNavLink trackingData="TopNav:Authentication" to={`/customize/${putterId}/auth`} activeClassName="active"><span className="customize-nav-label">Authentication</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
    <li>
      <TrackedNavLink trackingData="TopNav:Confirm" to={`/customize/${putterId}/${confirmLink}`} activeClassName="active"><span className="customize-nav-label">Confirm</span><div className="customize-nav-link-underline"></div></TrackedNavLink>
    </li>
  </ul>

CustomizeNav.propTypes = {
  putterId: PropTypes.string, 
  page: PropTypes.string,
}


export default CustomizeNav